import { Banner } from "../components/Banner";
import { Projects } from "../components/Projects";
import { Testimonials } from "../components/Testimonials";
import { Footer } from "../components/Footer";

export const Home = ({ musicOn, onToggleMusic, musicClock, onOpenContact }) => {
  return (
    <>
      <Banner musicOn={musicOn} onToggleMusic={onToggleMusic} musicClock={musicClock} />
      <Projects />
      <Testimonials />
      <Footer onOpenContact={onOpenContact} />
    </>
  );
};
